import { render, staticRenderFns } from "./mProjectDetail.vue?vue&type=template&id=aa3ba16e&scoped=true"
import script from "./mProjectDetail.vue?vue&type=script&lang=js"
export * from "./mProjectDetail.vue?vue&type=script&lang=js"
import style0 from "./mProjectDetail.vue?vue&type=style&index=0&id=aa3ba16e&prod&lang=scss&scoped=true"
import style1 from "./mProjectDetail.vue?vue&type=style&index=1&id=aa3ba16e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3ba16e",
  null
  
)

export default component.exports